/**
 * Parses a comma-separated keyword string from the backend into an array of
 * trimmed, non-empty keyword strings suitable for the tag/chip input.
 *
 * @param {string|null|undefined} keywordsStr – e.g. "pricing, quote, demo"
 * @returns {string[]} – e.g. ["pricing", "quote", "demo"]
 */
export function parseKeywords(keywordsStr) {
  if (!keywordsStr || typeof keywordsStr !== 'string') return [];
  return keywordsStr
    .split(/[,;\n]+/)
    .map((k) => k.trim())
    .filter((k) => k.length > 0);
}

/** True when trim + lower case match. First chip casing stays. */
export function isSameKeyword(a, b) {
  return String(a).trim().toLowerCase() === String(b).trim().toLowerCase();
}

/**
 * Serialises chips to the comma-separated string the backend stores.
 * Drops later chips that match an earlier one ignoring case.
 *
 * @param {string[]} chips
 * @returns {string}
 */
export function formatKeywords(chips) {
  if (!Array.isArray(chips)) return '';
  const result = [];
  for (const chip of chips) {
    const clean = String(chip).trim();
    if (!clean || result.some((existing) => isSameKeyword(existing, clean))) {
      continue;
    }
    result.push(clean);
  }
  return result.join(', ');
}

/** Maximum total character length for the serialised keywords string. */
export const KEYWORDS_MAX_CHARS = 500;
